import React, { Component } from "react";
import List from 'devextreme-react/list';
import RelatorioFatDecSn from "../relatorioFatDecSn/relatorioFatDecSn";
import react from "react";
import { Popup, ScrollView, Tabs } from "devextreme-react";
import { Item } from "devextreme-react/tabs"
import PainelSn from "./PainelIssSimplesNacional";



export default class PainelIssBox extends Component {


    constructor(props) {
        super(props);

        console.log("props iss box", props)

        this.state = { selectedIndex: props.location?.aba ?? 0 };

        this.tabItens = [

            { id: 0, text: "Simples" },
            { id: 1, text: "Notas" },
            { id: 2, text: "Escriturações" },
            { id: 3, text: "Ferramentas" },
        ]
        this.relatorios = [
            { id: 1, descricao: "Relatório 1", path: "/relatorio_fat_dec_sn" },
            { id: 2, descricao: "Relatório 2" },
            { id: 3, descricao: "Relatório 3" },
            { id: 4, descricao: "Relatório 4" },
        ];

        this.selecionarRelatorio = this.selecionarRelatorio.bind(this);
        this.tabSelecionada = this.tabSelecionada.bind(this);
    }

    tabSelecionada(args) {

        if (args.name === 'selectedIndex') {
            this.setState({
                selectedIndex: args.value,
            });
            console.log(args.value);
        }
    }

    selecionarRelatorio(item) {
        const data = item.itemData;
        if (data != undefined && data.path != undefined) {
            this.props.history.push(data.path);
        }
    }



    render() {
        return (
            <div className={"content-block dx-card responsive-paddings"}>
                <h3 style={{ textAlign: "center", fontWeight: "bold" }}>PAINEL DO ISS</h3>

                <Tabs
                    dataSource={this.tabItens}
                    selectedIndex={this.state.selectedIndex}
                    onOptionChanged={e => this.tabSelecionada(e)}
                />

                {this.state.selectedIndex == 0 ? <PainelSn history={this.props.history} /> : null}

            </div >


        );

    }
}